import { configFromEnv, getBlochainByChainId } from './utils';
import { postRequestConfig } from './const';

type MethodToTypes = {
  ankr_getTokenPrice: [
    { blockchain: string; contractAddress?: string },
    { blockchain: string; contractAddress?: string; usdPrice: string },
  ];
};

type Method = keyof MethodToTypes;

interface IRpcReqParams {
  method: Method;
  params: MethodToTypes[Method][0];
}

const buildRpcRequestData = ({ method, params }: IRpcReqParams) => {
  return {
    jsonrpc: '2.0',
    method,
    params,
    id: Date.now(),
  };
};

const config = configFromEnv();

export const getAdvancedApi = <T extends Method>(
  method: T,
  params: MethodToTypes[T][0],
): Promise<MethodToTypes[T][1]> => {
  const body = buildRpcRequestData({ method, params });

  return fetch(config.advancedApiUrl, {
    ...postRequestConfig,
    body: JSON.stringify(body),
  })
    .then(res => res.json())
    .then(res => res.result);
};

const ZERO_PRICE = '0';

/**
 * @docs https://www.ankr.com/docs/advanced-api/token-methods/#ankr_gettokenprice
 *
 * @param chainId - The chain ID to get the token price for.
 * @param tokenAddress - The token address to get the price for. If not provided, the price for the native currency will be returned.
 *
 * @returns The token price in USD.
 */
export const getTokenPriceByChainId = async (
  chainId: number,
  tokenAddress?: string,
): Promise<string> => {
  const blockchain = getBlochainByChainId(chainId);

  return getAdvancedApi('ankr_getTokenPrice', {
    blockchain,
    contractAddress: tokenAddress,
  }).then(res => res?.usdPrice || ZERO_PRICE);
};
